import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadResumesTransactionCandidatesModalComponent } from './upload-resumes-transaction-candidates-modal.component';
import { CandidateCardModule } from 'src/app/pages/mission-control-page/candidates-page/candidate-card/candidate-card.module';

@NgModule({
  declarations: [UploadResumesTransactionCandidatesModalComponent],
  imports: [
    CommonModule,
    CandidateCardModule
  ],
  exports: [UploadResumesTransactionCandidatesModalComponent],
  entryComponents: [UploadResumesTransactionCandidatesModalComponent]
})
export class UploadResumesTransactionCandidatesModalModule { }
